import PropTypes from "prop-types";

import { SYSTEM_FOR_ARCHETYPE, boardSystem, systemLabel } from "../liveTap/liveSystem";
import styles from "./LiveBoardStates.module.scss";

/**
 * Shared non-canvas states for the experimental live systems (TT-1046).
 *
 * PaperWait: the t=0 frame. A recorder letters the title before anyone
 * speaks, so the waiting state is a paper page with the meeting title
 * already inked — not a spinner in the dark. It carries no "wait for
 * content" hint (TT-1133): the opening sketch letters the first sentence
 * as soon as there is one, so this frame only ever shows before anything
 * has been said, or on a closed meeting that drew nothing.
 *
 * StyleMismatch: a doc's board keeps the archetype it was created with;
 * when the selected style can't render it, say which one can (the silent
 * alternative is an eternal "warming up" spinner).
 */
export function PaperWait({ title, hint }) {
  return (
    <div className={styles.paper}>
      <div className={styles.paperTitle}>{title || "Live Tapestry"}</div>
      <div className={styles.paperRule} />
      {hint && <div className={styles.paperHint}>{hint}</div>}
    </div>
  );
}

PaperWait.propTypes = {
  title: PropTypes.string,
  hint: PropTypes.string,
};

export function StyleMismatch({ archetype }) {
  const owner = systemLabel(SYSTEM_FOR_ARCHETYPE[archetype] || archetype);
  return (
    <div className={styles.mismatch}>
      This meeting is being drawn by the <strong>{owner}</strong> style — a board keeps
      the style it started with. Switch the style selector to {owner} to see it.
    </div>
  );
}

StyleMismatch.propTypes = {
  archetype: PropTypes.string,
};

/** True when the doc already has a board that this system cannot render. */
export function isStyleMismatch(board, expectedSystem) {
  const owner = boardSystem(board);
  return owner != null && owner !== expectedSystem;
}
